/**
 * Responsável por .
 * @author: fabio.junior
 * Date: 10/12/13
 * Time: 15:11
 */

Greenmile.MarkerOrder = Greenmile.MarkerOrder || {};
Greenmile.MarkerOrder.GeneralFunctions = function () {

    Greenmile.Marker.GeneralFunctions.apply(this, arguments);

    this.orderPopupMap = function (data) {
        var div               = document.createElement("div"),
            stopDetail        = document.createElement("div"),
            h4                = document.createElement("h4"),
            stopDetailAddress = document.createElement("div");

        div.className = "stopDetail";

        stopDetail.className = "stopDetailContent";
        h4.textContent = data.location.key + " - " + data.location.description;

        stopDetailAddress.className = "stopDetailAddress";
        stopDetailAddress.textContent = data.address.join(", ");

        stopDetail.appendChild(h4);
        stopDetail.appendChild(stopDetailAddress);

        var stopDetailWindow = Greenmile.Templates.stopDetailWindow;

        if (data.number) {
            var a = document.createElement("a");
            a.id = "linkToOrder";
            a.href = "#/RouteSummary/OrderAndLineItems";
            a.innerHTML = data.number;

            stopDetail.appendChild(stopDetailWindow({ span: data.orderNumberLabel, windowContent: a }));
        }

        if (data.plannedSize1) {
            stopDetail.appendChild(stopDetailWindow({
                span: data.plannedSize1Label,
                windowContent: document.createTextNode(data.plannedSize1)
            }));
        }

        if (data.plannedPickupSize1) {
            stopDetail.appendChild(stopDetailWindow({
                span: data.plannedPickupSize1Label,
                windowContent: document.createTextNode(data.plannedPickupSize1)
            }));
        }

        div.appendChild(stopDetail);

        return div.outerHTML;
    };

    this.renderContentToPopup = function (order, marker) {

        var divParent = document.createElement('div');
        var divContent = document.createElement('div');
        var divCloseButton = document.createElement('div');

        var location = new App.Models.Location(order.location);
        var addressFormatted = location.getItemsOfAddress();
        var i18n = Monet.I18n;

        var eventToClosePopup = function (context, marker) {

            return function () {
                marker.closePopup();
            };

        }(this, marker);

        divContent.className = 'pendingOrderPopupDetail';
        divContent.innerHTML = this.orderPopupMap({
            location: location.attributes,
            address: addressFormatted,
            orderNumberLabel: i18n.getResourcesByKey('Greenmile.PendingOrders.labelNumberPopup'),
            number: order.order.number,
            plannedSize1Label: i18n.getResourcesByKey('Greenmile.PendingOrders.labelPlannedSize1Popup'),
            plannedSize1: order.order.plannedSize1,
            plannedPickupSize1Label: i18n.getResourcesByKey('Greenmile.PendingOrders.labelPlannedPickupSize1Popup'),
            plannedPickupSize1: order.order.plannedPickupSize1
        });

        divCloseButton.className = 'mapsBtnClosePopup';
        divCloseButton.innerHTML = 'x';
        divCloseButton.removeEventListener('click', eventToClosePopup);
        divCloseButton.addEventListener('click', eventToClosePopup);

        divParent.appendChild(divCloseButton);
        divParent.appendChild(divContent);

        var link = divParent.querySelector('#linkToOrder');

        if (link !== null) {
            var hash = "#/RouteSummary/OrderAndLineItems";

            var goToOrder = function (context) {

                return function () {
                    var model = new App.Models.Stop();
                    model.set({
                        order: { number: context.order.number }
                    });
                    App.Forms.RouteSummaryOrders.stop = model;

                    Monet.Grid.Utils.clearPagination('RouteSummaryOrders');

                    if (hash === window.location.hash) {

                        App.Views.RouteSummary.showOrdersAndLineItems();

                    } else {

                        window.location = hash;

                    }
                };

            }(order);

            link.addEventListener('click', goToOrder);
        }

        return divParent;

    };

    this.createMarker = function (order) {

        var location = order.location;
        this.setModel(order);

        var params = {
            position: [
                location.latitude,
                location.longitude
            ],
            kind: Greenmile.Marker.Kind.ORDER,
            offset: [40, -38],
            minWidth: 355
        };

        return this.createGenericMarker(order.order.number, params);

    };

};

